import dayjs from 'dayjs';

export default {
  nonExplicitSupportedLngs: true,
  keySeparator: false,
  detection: {
    lookupQuerystring: 'locale'
  },
  interpolation: {
    escapeValue: false,
    format(value, format) {
      if (dayjs.isDayjs(value)) {
        return value.format(format);
      }
      return value;
    }
  },
  react: {
    useSuspense: false
  },
  debug: false,
  ns: [
    'agreementPolicy',
    'booking',
    'bookingDetails',
    'bookingPreference',
    'bookingsMade',
    'bookingsReceived',
    'cancellationPolicy',
    'checkout',
    'cookiePolicy',
    'countries',
    'cta',
    'dashboard',
    'dateFormat',
    'dates',
    'deleteAccount',
    'duration',
    'footer',
    'globalError',
    'help',
    'homePage',
    'howToPark',
    'listing',
    'listingDetails',
    'listingPageCalendar',
    'login',
    'longTermDurationPicker',
    'monthlyCheckout',
    'navigation',
    'paymentDetails',
    'payments',
    'personalDetails',
    'privacyPolicy',
    'profile',
    'resetPassword',
    'search',
    'searchResultsFilters',
    'termsAndConditions',
    'trustWidget',
    'ui',
    'vehicle',
    'welshHelp'
  ],
  defaultNS: 'cta',
  fallbackLng: (code) => {
    if (!code) {
      return false;
    }

    if (code && code.startsWith('de')) {
      return 'de';
    }

    if (code && code.startsWith('cy')) {
      return 'cy';
    }

    return 'en';
  }
};
